import React, { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';

import { project_anim } from '../../utils';

function ProjectBox(props) {
    const box = useRef(null);

    useEffect(() => {
        if (props.type == null) return;
        if (props.type !== '2') return;
        const element = box.current;
        element.addEventListener('mouseenter', project_anim);

        return () => {
            element.removeEventListener('mouseenter', project_anim);
        }
    }, []); // eslint-disable-line

    // Generate a slug based on the index or heading
    const slug = props.slug || (props.heading ? props.heading.toLowerCase().replace(/ /g, '-') : 'impact-story');
    const cardContent = (
        <div className="project-list-single">
            <div className="project-list-single--content">
                <div className="project-list-single--content-inner">
                    <div className="project-single-service project-single-service-1">
                        <h3>{props.heading}</h3>
                    </div>
                    <h2>{props.description}</h2>
                    <div className="project-single-service project-single-service-2 project-single-client">
                        <h3>
                            {props.name}
                            <span>—</span>
                            {props.namespan}
                        </h3>
                    </div>
                    {!props.disableLink && (
                        <div className="project-single-button">
                            <div className="project-single-button--inner">
                                <i className="fas fa-arrow-right"></i>
                            </div>
                        </div>
                    )}
                </div>
            </div>
            <div className="project-list-single--thumbnail">
                {props.image && <img src={props.image} alt={props.alt} />}
            </div>
        </div>
    );

    if (props.disableLink) {
        return (
            <div className="project-list-single--wrapper" ref={box}>
                {cardContent}
            </div>
        );
    }

    return (
        <Link to={`/impact/${slug}`} className="project-list-single--wrapper" ref={box}>
            {cardContent}
        </Link>
    );
}

export default ProjectBox;
